import {
  call, put, select, takeEvery,
} from 'redux-saga/effects';
import callAdapter from '@/utils/sagaHelper';
import findResult, { wildcardFilter } from '@/utils/resultsHelper';
import selectors from '@/selectors';
import CohortsService from '@/cohorts/service';
import { showRequestSourceError } from '../../actions';
import { cohortToRequest, cohortToRequestError, showRequestCohorts } from '../actions';
import actions from '../constants';

export function* queries({
  category,
  code,
  cohortCode,
  names,
}) {
  const { response, error } = yield call(callAdapter, CohortsService.cohortQueries(cohortCode));
  if (error) {
    yield put(showRequestSourceError(category, code, error));
  } else {
    yield put(cohortToRequest(category, code, response.items, names));
  }
}

export function* cohorts(action) {
  const items = yield select(selectors.requests);
  const item = findResult(items, action.category, action.code);
  const {
    filter, pageSize, currentPage, privateFlag, internalFlag,
  } = item.steps.cohorts;
  const page = action.page || currentPage;
  const size = action.pageSize || pageSize;
  const includePrivate = action.privateFlag || privateFlag;
  const includeInternal = action.internalFlag || internalFlag;
  const { response, error } = yield call(callAdapter, CohortsService.cohorts(
    wildcardFilter(filter),
    includePrivate,
    includeInternal,
    page,
    size,
    true,
  ));

  if (error) {
    yield put(cohortToRequestError(action.category, action.code, error));
  } else {
    yield put(showRequestCohorts(
      action.category,
      action.code,
      action.append,
      size,
      response.items,
      response.paging.total,
      response.paging.pages,
      response.paging.page,
    ));
  }
}

export default function* requestCohortsApi() {
  yield takeEvery(actions.FETCH_REQUEST_QUERIES, queries);
  yield takeEvery([actions.FETCH_REQUEST_COHORTS, actions.UPDATE_REQUEST_COHORTS_FLAGS], cohorts);
}
